module.exports = __webpack_public_path__ + "static/cardinal-puff-bc75d92b3f7a0ccba72487f82348654f.jpg";